module.exports = __webpack_public_path__ + "static/media/edit_icon.c4517144.svg";